import styled from 'styled-components';
import Button from '../Shared/Button'
import SpinnerComponent from '../Shared/SpinnerComponent';
import { useTranslation } from 'react-i18next';

export const OptionContainer = styled.div`
    padding: 3px 10px;
    &:hover {
        background-color: #E0F5FF;
        cursor: pointer;
    };
`;

export const SelectedOptionContainer = styled.div`
    padding: 3px 10px;
`;

export const InputRow = styled.div`
    display: flex;
    align-items: center;
    > * {
        padding: 2px 15px;
    }
`;

export const InputLabel = styled.label`
    width: calc(max(20%, 150px));
`;

export const SelectorWrapper = styled.div`
    min-width: calc(min(400px, 60%));
`;

export const TextInputWrapper = styled.div`
    min-width: calc(min(400px, 60%));
`;

const SubmitButtonRow = styled(InputRow)`
`;

const SubmitButtonWrapper = styled.div`
    padding-top: 10px;
    padding-bottom: 10px;
    button {
        margin: 0px !important;
    }
`;

export const SubmitButton = ({ handleClick, disabled }: { handleClick: () => void; disabled?: boolean }) => {
    const [t] = useTranslation();
    return(
        <SubmitButtonRow>
            <SubmitButtonWrapper>
                <Button onClick={handleClick} className={'btn btn-primary standard'} disabled={disabled}>{t('submit_update')}</Button>
            </SubmitButtonWrapper>
        </SubmitButtonRow>)
}

const SpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
`;

export const SpinnerContainer = () =>
    <SpinnerWrapper>
        <SpinnerComponent width={50} height={50} />
    </SpinnerWrapper>